module.exports = __webpack_public_path__ + "static/media/signup-bg.2f8eae0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/signup-bg.jpg
// module id = 135
// module chunks = 0